module.exports = __webpack_public_path__ + "img/Dantam Hair 51.a18d7645.jpg";